import React from 'react'
import AdminLoginComponent from 'components/Panel/Admin/Login'

const LoginContainer = () => {
  return (
    <AdminLoginComponent/>
  )
}

export default LoginContainer